import { initializeDownload } from '../lib/fileUtils';

export class AssetsDownload {
	static handle( downloadJson, assetDownloadService ) {
		const download = AssetsDownload.fromJSON( downloadJson );
		download.handleWith( assetDownloadService );

		return download;
	}

	static fromJSON( json ) {
		return new AssetsDownload( {
			id: json.download_id,
			type: json.download_type,
			contentType: json.download_content_type,
			url: json.download_url
		} );
	}

	constructor( { id, type, contentType, url } ) {
		this.id = id;
		this.type = type;
		this.contentType = contentType;
		this.url = url;
	}

	handleWith( assetDownloadService ) {
		if ( this.isDirectDownload ) {
			initializeDownload( this.url );
		} else {
			assetDownloadService.registerDownload( this.id, this.contentType );
		}
	}

	get isDirectDownload() {
		return this.type === 'sync';
	}
}
